import styled from "styled-components";

export const DesContent = styled.div`
	white-space: pre-line;
`;
